<template>
  <v-container class="pa-0 ma-0"></v-container>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { track } from "@/services/track-custom";
import { misMixins } from "@/mixins/mixins.js";

export default {
  name: "RouteProduct",
  computed: {
    ...mapState('shared', ["product_id"]),
    ...mapState('order', ["service"]),
  },
  created() {
    this.reloadGetSupplier();
    track.trackEventCluvi({}, "qa ruta directa producto");
    this.SetProductId(this.$route.params.product_id);
    if(this.service === 'on_table'){
      this.$router.push({ name: 'OnTableHome', params: { supplier_id: this.$route.params.supplier_id } });
    }else{
      this.$router.push({ name: 'Home', params: { supplier_id: this.$route.params.supplier_id } });
    }
    
  },
  mixins: [ misMixins],
  methods:{
    ...mapMutations('shared', ["SetProductId"])
  }
};
</script>